<template>
  <div class="printOrderDetails">
    <!-- 订单状态 -->
    <div class="detailsState">
      <div class="detailsState_one">
        <i
          class="el-icon-arrow-left"
          @click="$router.push('/designOrderList')"
        ></i>
        <p class="detailsState_one_title">订单状态</p>
          <span v-if="designerInfo.designStatus==='UN_PAY'">已报价，买家已确认</span>
          <span v-if="designerInfo.designStatus==='PLATFORM_ADVANCES_UN_CONFIRM'">先行支付确认中</span>
          <span v-if="designerInfo.designStatus==='UN_DESIGN'">用户已支付，待设计</span>
          <span v-if="designerInfo.designStatus==='UN_CONFIRM'">已提交作品，待用户验收</span>
          <span v-if="designerInfo.designStatus==='UN_APPRAISE'">交易已完成</span>
          <span v-if="designerInfo.designStatus==='UN_CANCEL'">交易已取消</span>
      </div>
      <!--<div class="detailsState_one">
        <p>
          商家还有
          <span class="detailsState_one_time">3天15小时30分20秒</span>
          来确认设计师，超时需求将自动关闭
        </p>
      </div>-->
    </div>
    <!-- 报价流程 -->
    <div class="details">
      <div class="detailsProcess">
          <div class="processItem" v-if="designerInfo.designStatus!=='UN_CANCEL' && orderBase.payType == 'PLATFORM_ADVANCES' && orderBase.payChannel == 'PLATFORM_ADVANCES'" v-for="(item,index) in processList1" :key="index">
              <div :class="designerInfo.designStatus === item.id?'process_type process_type2':'process_type'">
                  <i>{{index + 1}}</i>
                  <p>{{item.name}}</p>
              </div>
              <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
          </div>
          <div class="processItem" v-if="designerInfo.designStatus!=='UN_CANCEL' && orderBase.payType !== 'PLATFORM_ADVANCES' && orderBase.payChannel !== 'PLATFORM_ADVANCES'" v-for="(item,index) in processList" :key="index">
              <div :class="designerInfo.designStatus === item.id?'process_type process_type2':'process_type'">
                  <i>{{index + 1}}</i>
                  <p>{{item.name}}</p>
              </div>
              <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
          </div>
      </div>
      <!-- 订单信息 -->
      <div class="orderMessage">
        <div class="orderMessage_title">
          <h4>订单信息</h4>
          <p>设计师：{{ designerInfo.designerName }}</p>
        </div>
        <div class="orderMessage_con">
          <p>订单编号：{{ orderBase.orderNo }}</p>
          <p>需求发布时间：{{ demandInfo.publishTime }}</p>
          <p>确认设计师时间：{{ orderBase.createDate }}</p>
        </div>
        <div class="orderMessage_con" v-if="orderBase.payType!=null">
          <p>付款时间：{{ orderBase.payDate }}</p>
          <p>付款渠道：{{ orderBase.payChannelCn }}</p>
          <p>订单金额：¥{{ orderBase.totalPrice }}</p>
        </div>
      </div>
      <!-- 需求信息 -->
      <div class="orderMessage">
        <div class="orderMessage_title">
          <h4>需求信息</h4>
        </div>
        <div class="orderMessage_con">
          <p>需求名称：{{ designerInfo.demandName }}</p>
        </div>
        <div class="orderMessage_con">
          <p>需求类型：{{ demandInfo.demandTypeCn }}</p>
          <p>交付文件类型：{{ demandInfo.fileType }}</p>
            <p v-if="demandInfo.demandType == 'MODEL'">规格尺寸：{{demandInfo.specificationsStart}} - {{demandInfo.specificationsEnd}} cm</p>
        </div>
        <div class="orderMessage_con">
          <p>报名截止日期：{{ demandInfo.deadline }}</p>
          <p>期望日期：{{ demandInfo.expectedDeliveryTime }}</p>
          <p>预算金额：¥{{ demandInfo.lowPreAmount }}-{{ demandInfo.highPreAmount }}</p>
          <p>支付方式：{{ demandInfo.payTypeCn }}</p>
        </div>
        <div class="orderMessage_con">
          <p style="width:100%"><span>需求描述：</span> <span v-html="demandInfo.demandDes" class="vHtmlMess"></span></p>
        </div>
        <div class="orderMessage_con">
          <p v-for="(item,index) in demandInfo.demandAttachments" :key="index">
              <span style="color: #1890FF;cursor: pointer;margin-right: 20px;" @click="downloadFile(item.fileUrl)">{{ item.fileName }}</span>
          </p>
        </div>
      </div>
      <!-- 报价详情 -->
      <div class="orderMessage" style="border: none">
        <div class="orderMessage_title">
          <h4>报价详情</h4>
        </div>
        <el-table :border="true" :data="tableData" style="width: 100%">
          <el-table-column prop="designer" label="设计师" align="center">
            <template slot-scope="scope">
              <div class="designerImg">
                <img :src="scope.row.designIconUrl" alt="" />
                <div>
                  <p>{{ scope.row.designName }}</p>
                  <!-- <i class="el-icon-message-solid"></i> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="报价时间" align="center">
          </el-table-column>
          <el-table-column prop="offer" label="报价金额" align="center">
          </el-table-column>
          <el-table-column prop="planDeliveryTime" label="计划工期" align="center">
            </el-table-column>
            <el-table-column prop="designerAttachmentForDemands" label="附件" align="center">
                <template slot-scope="scope">
                    <div v-for="(item,index) in scope.row.designerAttachmentForDemands" :key="index">
                        <span @click="downloadFile(item.fileUrl)" style="color: #1890FF;cursor: pointer;">{{ item.fileName }}</span>
                    </div>
                </template>
            </el-table-column>
          <el-table-column
            prop="remark"
            label="报价说明"
            width="400"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 设计详情 -->
      <div class="orderMessage" style="border: none">
        <div class="orderMessage_title">
          <h4>设计详情</h4>
        </div>
          <el-table :data="designerTableData"
                    :border="true"
                    :span-method="arraySpanMethod"
                    style="width: 100%">
              <el-table-column
                  label="序号"
                  type="index"
                  width="100"
                  align="center">
              </el-table-column>
              <el-table-column prop="designerText" label="设计文件" align="center">
                  <template slot-scope="scope">
                      <div class="">
                          <p>{{ scope.row.name }}</p>
                          <div>
                              <el-button type="text" size="small" @click="viewImg(scope.row.url)">预览</el-button>
                              <el-button type="text" size="small" @click="downloadFile(scope.row.url)">下载</el-button>
                          </div>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column label="设计说明" align="center">
                  <template slot-scope="scope">
                      {{ description }}
                  </template>
              </el-table-column>
              <el-table-column label="附件" align="center">
                  <template slot-scope="scope">
                      <div class="textNames" v-for="(item,index) in fileList" :key="index">
                          <p @click="downloadFile(item.url)">{{ item.name }}</p>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column prop="createTime" label="上传时间" align="center">
              </el-table-column>
              <el-table-column label="确认时间" align="center">
                  <template slot-scope="scope">
                      {{ confirmTime }}
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <!-- 修改记录 -->
      <div class="orderMessage" style="border: none">
        <div class="orderMessage_title">
          <h4>修改记录</h4>
        </div>
        <div class="orderRecordBox">
          <div class="orderRecord" v-for="(itemList,index) in orderRecordList" :key="index">
            <div class="orderRecordL">
              <div class="orderRecordL_one">
                <i></i>
                <p></p>
              </div>
              <div class="orderRecordL_Box">
                <div class="orderRecordL_img">
                  <div class="orderRecordL_imgIcon"
                      v-if="itemList.modelList.length > 5"
                      @click="getOrderImg('left',index,itemList.modelList.length)"
                  >
                      <i class="el-icon-arrow-left"></i>
                  </div>
                  <div
                    class="recordL_imgBox"
                  >
                    <div
                      class="orderRecordL_imgBox"
                      v-for="(modelInfo,indexs) in itemList.modelList"
                      :key="indexs"
                      @click="viewImg(modelInfo.url)"
                      ref="recordMess"
                    >
                      <p>{{modelInfo.name}}</p>
                      <img :src="modelInfo.url" alt="" />
                    </div>
                  </div>

                  <div
                    class="orderRecordL_imgIcon2"
                    v-if="itemList.modelList.length > 5"
                    @click="getOrderImg('right',index,itemList.modelList.length)"
                  >
                      <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="orderRecordL_mess">
                  <div class="orderRecordL_messBox">
                    <p>备注：</p>
                    <p>{{itemList.description}}</p>
                  </div>
                  <div class="orderRecordL_messBox">
                    <p>附件：</p>
                      <div v-for="(fileInfo,index) in itemList.fileList" :key="index">
                          <p @click="downloadFile(fileInfo.url)" style="color: #1890FF;cursor: pointer;margin-right: 20px;">{{fileInfo.name}}</p>
                      </div>
                  </div>
                  <div class="orderRecordL_messBox">
                    <p>上传时间：</p>
                    <p>{{itemList.createTime}}</p>
                  </div>
                  <div class="amendments">
                    <p>修改意见：</p>
                    <p>{{itemList.updateRemark}}</p>
                    <p class="amendments_time">意见提交时间：{{itemList.confirmTime}}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
          <div class="orderRecordButton">
              <el-button class="operationUploadBtn" v-if="designerInfo.designStatus==='PLATFORM_ADVANCES_UN_CONFIRM'" @click="confirmDesign(designerInfo)">确认垫付</el-button>
              <el-button class="operationUploadBtn" v-if="designerInfo.designStatus==='UN_APPRAISE' && designerInfo.platformAdvances && !designerInfo.orderBase.payDate" @click="confirmDesignPay(designerInfo)">确认打款</el-button>
          </div>
      </div>
    </div>
      <el-dialog
          title="图片预览"
          :close-on-click-modal="false"
          :append-to-body="true"
          :visible.sync="visibleImg">
          <div class="modal-content">
              <el-row v-if="isShowImgUpload" style="padding-left:100px;padding-right:100px;">
                  <el-col :span="4" style="color:white">1</el-col>
                  <el-col :span="16">
                      <div style="position:relative;background-color: #f0f3fa;">
                          <img
                              :src="localUrl"
                              :preview-src-list="[localUrl]"
                              style="width:100%;height:100%;"
                              fit="scale-down"
                          />
                      </div>
                  </el-col>
                  <el-col :span="4" style="color:white">1</el-col>
              </el-row>
          </div>
      </el-dialog>
      <!-- 3d预览 -->
      <three-d
          ref="threeBox"
          :innerVisible="innerVisible"
          :fileListNew="fileListNew"
          @closeDlog="closeDlog"
      ></three-d>
  </div>
</template>

<script>
import threeD from "../../components/threeD/index";
import {
    getDesignOrderDetail, getDesignInfoDetail, getDesignerDemandFile,
    findChooseDemandOffer, findUpdateRemark, platformAdvancesConfirm, platformAdvancesConfirmPay
} from '../../utils/interface';
export default {
  name: "printOrderDetails",
  components: {
    threeD,
  },
  data() {
    return {
        tableData: [],
        designerTableData: [],
        fileList:[],
        description: "",
        confirmTime: "",
        uuid:"",
        designerInfo:"",
        orderBase:"",
        demandInfo:"",
        // 图片预览
        isShowImgUpload:false,
        localUrls:"",
        visibleImg:false,
        orderRecordList:[],
        // 3D预览
        fileListNew: [],
        innerVisible: false,
        base64img:"",
        rotation: {
            // x: -Math.PI / 2,
            x: 200,
            y: 0,
            z: 100,
        },
        processList: [
            {
                id: '',
                name: '需求报价'
            },
            {
                id: '',
                name: '确认设计师'
            },
            {
                id: 'UN_PAY',
                name: '订单支付'
            },
            {
                id: 'UN_DESIGN',
                name: '设计中'
            },
            {
                id: 'UN_CONFIRM',
                name: '设计确认'
            },
            {
                id: 'UN_APPRAISE',
                name: '设计评价'
            },
            {
                id: 'FINISHED',
                name: '完成'
            },
            {
                id: 'UN_CANCEL',
                name: '订单已取消'
            },
        ],
        processList1: [
            {
                id: '',
                name: '需求报价'
            },
            {
                id: '',
                name: '确认设计师'
            },
            {
                id: 'UN_PAY',
                name: '订单支付'
            },
            {
                id: "PLATFORM_ADVANCES_UN_CONFIRM",
                name: "先行支付确认中",
            },
            {
                id: 'UN_DESIGN',
                name: '设计中'
            },
            {
                id: 'UN_CONFIRM',
                name: '设计确认'
            },
            {
                id: 'UN_APPRAISE',
                name: '设计评价'
            },
            {
                id: 'FINISHED',
                name: '完成'
            },
            {
                id: 'UN_CANCEL',
                name: '订单已取消'
            },
            ]
    };
  },
    created(){
        this.uuid = this.$route.params.uuid;
        this.getDesignOrderDetail();
    },
    mounted(){
        this.snapshot();
    },
  methods: {
      snapshot() {
          this.base64img = this.$refs.model[0].renderer.domElement.toDataURL('image/png', 1);
      },
      closeDlog(index){
          this.innerVisible = index;
      },
      viewImg(url){
          if(url.substr(url.lastIndexOf('.')+1).toUpperCase()==="STL"){
              this.$refs.threeBox.threeAnimal({url:url});
              this.innerVisible = !this.innerVisible;
          } else if (url.substr(url.lastIndexOf('.')+1).toUpperCase()==="OBJ") {
              this.$message.error("暂不支持预览OBJ格式");
          } else {
              this.$nextTick(() => {
                  this.showImg(url);
              });
          }
      },
      showImg (url) {
          this.visibleImg = true;
          this.localUrl = url;
          this.isShowImgUpload = true;//呈现本地预览组件
      },
      getDesignOrderDetail(){
          getDesignOrderDetail({uuid:this.uuid}).then((res)=>{
              this.designerInfo = res;
              this.orderBase = res.orderBase;
              getDesignInfoDetail({uuid:res.demandUuid}).then((res)=>{
                  this.demandInfo = res;
                  // 设计详情
                  this.getDesignerDemandFile();
                  // 报价设计师
                  this.findChooseDemandOffer();
                  //  修改意见
                  this.findUpdateRemark();
              });
          });
      },
      findUpdateRemark(){
          let params = {
              isUpdate:1,
              demandUuid:this.designerInfo.demandUuid
          };
          findUpdateRemark(params).then((res)=>{
              if(res.success){
                  this.orderRecordList = res.data;
              }
          });
      },
      findChooseDemandOffer(){
          findChooseDemandOffer({uuid:this.demandInfo.uuid,winnerUuid:this.demandInfo.winnerUuid}).then((res)=>{
              if(res.success){
                  this.tableData = res.data;
              }
          });
      },
      getDesignerDemandFile(){
          let params = {
              isUpdate:0,
              demandUuid:this.designerInfo.demandUuid
          };
          getDesignerDemandFile(params).then((res)=>{
              if(res.success){
                  this.description = res.data.description;
                  this.confirmTime = res.data.confirmTime;
                  this.designerTableData = res.data.modelList;
                  this.fileList = res.data.fileList;
              }
          });
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }){
          if (columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5) {
              if(rowIndex ===0){
                  let rowspan = 0;
                  this.designerTableData.forEach(element => {
                      rowspan ++;
                  });
                  return [rowspan, 1];
              }else {
                  return [0, 0];
              }
          }
      },
      // 维修记录多余五条可以滑动
      getOrderImg(direction,index,length){
        let lengthNum = length - 5
        // let margitLeftNext = (leftIndex-1) * -250
        if(direction== 'left'){
          let leftIndex = this.orderIndex ++

          if(leftIndex <= lengthNum) {
            this.margitLeft = leftIndex * -250
            this.$refs.recordMess[index].style.marginLeft = this.margitLeft + 'px'

          }else {
            this.orderIndex = lengthNum
          }

        }else if(direction== 'right'){
          let leftIndex2 = this.orderIndex --
          if(leftIndex2 >= 2 ) {
            this.margitLeftNext = (leftIndex2 - 2) * -250
            this.$refs.recordMess[index].style.marginLeft = this.margitLeftNext + 'px'
          }else {
            this.orderIndex = 1
          }

        }
      },
      // 确认垫付
      confirmDesign(item) {
          this.$confirm('确认当前订单使用先行支付吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              platformAdvancesConfirm(item.orderBase.orderNo).then(res => {
                  if (res && res.success) {
                      this.$message.success(res.message);
                      this.searchInfo();
                  } else {
                      this.$message.error(res.message);
                  }
              });
          }).catch(() => {
          })
      },
      // 确认打款
      confirmDesignPay(item) {
          this.$confirm('确认已打款了吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              platformAdvancesConfirmPay(item.orderBase.orderNo).then(res => {
                  if (res && res.success) {
                      this.$message.success(res.message);
                      this.searchInfo();
                  } else {
                      this.$message.error(res.message);
                  }
              });
          }).catch(() => {
          })
      },
      downloadFile(fileUrl){
          let a = document.createElement('a');
          a.href = fileUrl;
          a.click();
      },
  },
};
</script>

<style scoped lang="less">
p {
  margin: 0;
}
i {
  font-style: normal;
}
.printOrderDetails {
  background: #f5f5f5;
  margin-left: 20px;
  // 订单状态
  .detailsState {
    background: #fff;
    font-size: 14px;
    padding: 26px 32px;
    margin-bottom: 8px;
    .detailsState_one {
      display: flex;
      align-items: center;
      &:nth-of-type(1) {
        margin-bottom: 16px;
      }
      i {
        font-size: 18px;
        margin-right: 5px;
        cursor: pointer;
      }
      .detailsState_one_title {
        font-size: 16px;
        font-weight: 500;
        margin-right: 8px;
      }
      .detailsState_one_time {
        color: #1890ff;
      }
    }
  }
  // 报价流程
  .details {
    background: #fff;
    padding: 0 8px;
    .detailsProcess {
      border-bottom: 1px solid #efefef;
      display: flex;
      align-items: center;
        .processItem{
            display: flex;
            align-items: center;
        }
      .process_type {
        width: 187px;
        height: 64px;
        // line-height: 64px;
        display: flex;
        align-items: center;
        // border-bottom: 2px solid #1890ff;
        text-align: center;
        justify-content: center;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 50%;
          color: rgba(0, 0, 0, 0.15);
          line-height: 27px;
          font-size: 14px;
          margin-right: 8px;
        }
        p {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.3);
        }
      }
      .typeIcon {
        color: rgba(0, 0, 0, 0.3);
        font-size: 18px;
      }
      .process_type2 {
        border-bottom: 3px solid #1890ff;
        i {
          background: #1890ff;
          color: #fff;
          border: 1px solid #1890ff;
        }
        p {
          color: #000;
        }
      }
    }
    // 订单信息
    .orderMessage {
      border-bottom: 1px solid #efefef;
      margin: 0 24px;
      padding-bottom: 8px;
      .textNames {
        p {
          color: #1890ff;
          cursor: pointer;
        }
      }
      .orderMessage_title {
        height: 64px;
        display: flex;
        align-items: center;
        h4 {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-right: 24px;
        }
        p {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          margin-right: 15px;
        }
        i {
          color: #1890ff;
          cursor: pointer;
        }
      }
      .orderMessage_con {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 16px;
        p {
          width: 362px;
        }
      }
      .designerImg {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 8px;
        }
        i {
          color: #1890ff;
        }
      }
      .orderRecordBox {
        border-bottom: 1px solid #efefef;
        .orderRecord {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
          .orderRecordL {
            display: flex;
            .orderRecordL_one {
              position: relative;

              i {
                display: inline-block;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: #1890ff;
                // margin-bottom: 18px;
              }
              p {
                width: 1px;
                height: 85%;
                background: #efefef;
                position: absolute;
                left: 50%;
                transform: translate(-50%, 2px);
              }
            }
            .orderRecordL_Box {
              width: 1276px;
              .orderRecordL_img {
                margin-bottom: 32px;
                display: flex;
                align-items: center;
                margin-left: 84px;
                .orderRecordL_imgIcon {
                  width: 32px;
                  height: 32px;
                  background: #E5E5EA;
                  border-radius: 50%;
                  text-align: center;
                  line-height: 35px;
                  color: rgba(0, 0, 0, 0.31);
                  margin-right: 16px;
                  flex-shrink: 0;
                  cursor: pointer;
                  i {
                    font-weight: bold;
                  }
                }
                .recordL_imgBox {
                  display: flex;
                  align-items: center;
                  overflow-x: hidden;
                }
                .orderRecordL_imgIcon2 {
                  width: 32px;
                  height: 32px;
                  background: #E5E5EA;
                  border-radius: 50%;
                  text-align: center;
                  line-height: 35px;
                  color: rgba(0, 0, 0, 0.31);
                  margin-left: 16px;
                  cursor: pointer;
                  flex-shrink: 0;
                  i {
                    font-weight: bold;
                  }
                }
                .orderRecordL_imgBox {
                  text-align: center;
                  margin-right: 154px;
                  p {
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 10px;
                  }
                  img {
                    width: 96px;
                    height: 96px;
                    cursor: pointer;
                  }
                }

              }
              .orderRecordL_mess {
                margin-left: 84px;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                .orderRecordL_messBox {
                  display: flex;
                  line-height: 22px;
                  margin-bottom: 16px;
                  p:nth-of-type(1) {
                    flex-shrink: 0;
                  }
                  .orderRecordL_messSpan {
                    color: #1890FF;
                    cursor: pointer;
                  }
                }
                .amendments {
                  width: 1193px;
                  background: #FAFAFA;
                  border-radius: 2px;
                  padding: 16px;
                  width: 100%;
                  p {
                    font-weight: 500;
                    margin-bottom: 16px;
                  }
                  .amendments_time {
                    font-weight: 400;
                    color: #757575;
                  }
                }
              }
            }

          }
        }
      }
      .orderRecordButton {
        margin-top: 24px;
        text-align: right;
        margin-bottom: 70px;
      }
    }
  }
}
    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/designOrderDetail1.vue